
export function parseWindowsOS(os_info) {
  let osArch = " (32bit)";
  if(os_info.indexOf('64-bit')!==-1){
    osArch = " (64bit)";
  }
  if(os_info.indexOf('Windows 11')!==-1){
    return 'Windows 11' + osArch;
  } else if(os_info.indexOf('Windows 10')!==-1){
    return 'Windows 10' + osArch;
  }else if(os_info.indexOf("Windows 8.1")!==-1){
    return "Windows 8.1" + osArch;
  }else if(os_info.indexOf("Windows 8")!==-1){
    return "Windows 8" + osArch;
  }else if(os_info.indexOf("Windows 7")!==-1){
    return "Windows 7" + osArch;
  }else if(os_info.indexOf("Windows Vista")!==-1){
    return "Windows Vista" + osArch;
  }else if(os_info.indexOf("Windows XP")!==-1){
    return "Windows XP" + osArch;
  }else{
    return os_info;
  }
};

export function getWindowsOS() {
//   navigator.userAgentData.getHighEntropyValues(["platformVersion"])
//  .then(ua => {
//    if (navigator.userAgentData.platform === "Windows") {
//      const majorPlatformVersion = parseInt(ua.platformVersion.split('.')[0]);
//      if (majorPlatformVersion >= 13) {
//        console.log("Windows 11 or later");
//       }
//       else if (majorPlatformVersion > 0) {
//         console.log(majorPlatformVersion, "Windows 10");
//       }
//       else {
//         console.log("Before Windows 10");
//       }
//    }
//    else {
//      console.log("Not running on Windows");
//    }
//  });

  if(navigator.appVersion.indexOf("Windows NT 10.")!==-1){
    return 'Windows 10';
  } else if (navigator.appVersion.indexOf('Windows NT 6.4')!==-1) {
    return 'Windows 10';
  }else if(navigator.appVersion.indexOf("Windows NT 6.3")!==-1){
    return "Windows 8.1";
  }else if(navigator.appVersion.indexOf("Windows NT 6.2")!==-1){
    return "Windows 8";
  }else if(navigator.appVersion.indexOf("Windows NT 6.1")!==-1){
    return "Windows 7";
  }else if(navigator.appVersion.indexOf("Windows NT 6.0")!==-1){
    return "Windows Vista";
  }else if(navigator.appVersion.indexOf("Windows NT 5.2")!==-1){
    return "Windows XP";
  }else if(navigator.appVersion.indexOf("Windows NT 5.1")!==-1){
    return "Windows XP";
  }else{
    return '';
  }
};
